// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"baa67f39","455":"33a47164","977":"e89c645a"}[chunkId] + ".chunk.js";
};